import { ResourcePage } from "./ResourcePage";

export function Databases() {
  return (
    <ResourcePage
      type="Database"
      typeLabelSentence="database"
      typeLabelPlural="databases"
      kindOptions={["Postgres", "MSSQL", "MySQL"]}
    />
  );
}
